import { useState, useRef, useEffect, ChangeEvent, FocusEvent, MouseEvent } from 'react'
import { mergeRefs } from '@grupoboticario/flora-react-utils'
import { UseFloraTextareaProps } from './types'

export const useFloraTextarea = ({
  forwardedRef,
  onChange,
  onBlur,
  onMouseDownCapture,
}: UseFloraTextareaProps) => {
  const internalRef = useRef<HTMLTextAreaElement>(null)
  const [charCount, setCharCount] = useState(0)
  const [clicked, setClicked] = useState(false)

  const handleOnMouseUpCaptureLabel = () => {
    setClicked(true)
  }

  const handleOnMouseDownCaptureTextarea = (e: MouseEvent<HTMLTextAreaElement>) => {
    setClicked(true)
    if (onMouseDownCapture) {
      onMouseDownCapture(e)
    }
  }

  const handleOnBlur = (e: FocusEvent<HTMLTextAreaElement>) => {
    setClicked(false)
    if (onBlur) {
      onBlur(e)
    }
  }

  const handleOnChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    setCharCount(e.target.value.length)
    if (onChange) {
      onChange(e)
    }
  }

  useEffect(() => {
    if (internalRef?.current) {
      setCharCount(internalRef.current.value.length)
    }
  }, [internalRef])

  return {
    charCount,
    clicked,
    ref: mergeRefs(forwardedRef, internalRef),
    handleOnChange,
    handleOnMouseDownCaptureTextarea,
    handleOnMouseUpCaptureLabel,
    handleOnBlur,
  }
}
